import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _startsWithInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/starts-with";
import React, { useContext, useMemo } from 'react';
import cx from 'classnames';
import { Transition, TransitionGroup } from 'react-transition-group';
import { InputField, IconButton, ModalNextProvider } from '@jutro/components';
import { TranslatorContext } from '@jutro/locale';
import { useTableContext } from './TableContext';
import { ColumnsConfigModal } from './columnsConfig/ColumnsConfigModal';
import { messages } from './DataTable.messages';
export const TableBar = ({
  filterValue,
  onFilterChange,
  filterPlaceholder,
  selectionActions = [],
  showSelectionActions,
  disabled
}) => {
  const translator = useContext(TranslatorContext);
  const _useTableContext = useTableContext(),
    styles = _useTableContext.styles,
    columns = _useTableContext.columns;
  const columnsConfigurable = columns.configurable,
    columnsConfig = columns.config,
    setColumnsConfig = columns.setConfig;
  const columnsConfigAction = useMemo(() => {
    if (!columnsConfigurable) {
      return null;
    }
    const triggerColumnsConfigModal = async () => {
      try {
        const updatedConfig = await ModalNextProvider.showModal(React.createElement(ColumnsConfigModal, {
          initialColumns: columnsConfig
        }));
        setColumnsConfig(updatedConfig);
      } catch (_unused) {}
    };
    return React.createElement("div", {
      className: styles.columnsConfigAction
    }, React.createElement(IconButton, {
      icon: "mi-view-column",
      label: translator(messages.columnsConfig),
      onClick: triggerColumnsConfigModal
    }));
  }, [columnsConfigurable, styles.columnsConfigAction, translator, columnsConfig, setColumnsConfig]);
  const searchWrapperClassName = cx(styles.searchWrapper, {
    [styles.searchWrapperDisabled]: disabled
  });
  return React.createElement("div", {
    className: styles.tableBar
  }, React.createElement(InputField, {
    id: "search",
    icon: "mi-search",
    iconPosition: "right",
    placeholder: filterPlaceholder,
    className: searchWrapperClassName,
    controlClassName: styles.search,
    onValueChange: onFilterChange,
    value: filterValue,
    editable: !disabled
  }), React.createElement("div", {
    className: styles.actionPanel
  }, showSelectionActions && React.createElement(TransitionGroup, {
    component: null
  }, React.createElement(Transition, {
    timeout: 400
  }, state => {
    const actionBarStyles = cx(styles.selectionActions, {
      [styles.withBorder]: columnsConfigAction,
      [styles.transition]: state !== 'entered'
    });
    const buttonsStyles = cx(styles.buttons, {
      [styles.enter]: _startsWithInstanceProperty(state).call(state, 'enter')
    });
    return React.createElement("div", {
      className: actionBarStyles
    }, React.createElement("div", {
      className: buttonsStyles
    }, _mapInstanceProperty(selectionActions).call(selectionActions, ({
      icon,
      label,
      callback
    }) => React.createElement(IconButton, {
      key: label,
      icon: icon,
      label: label,
      onClick: callback
    }))));
  })), columnsConfigAction));
};
TableBar.__docgenInfo = {
  componentName: "TableBar",
  packageName: "@jutro/datatable",
  description: "",
  displayName: "TableBar",
  methods: [],
  actualName: "TableBar",
  props: {
    selectionActions: {
      defaultValue: {
        value: "[]",
        computed: false
      },
      required: false
    }
  }
};